import {computed} from "vue";
import useSwr from "@/core/composables/swr/useSwr";
import {teamApi} from "@/container";
import {AgendaOperator, operatorsFromAccesses} from "@/agenda/lib/operators";

export type {AgendaOperator};

/**
 * Staff of the current healthcenter, for the team view columns and the
 * operator picker.
 *
 * Sourced from access/team rather than healthcenter/operators: the latter
 * returns environment ids, which cannot be joined to an appointment's
 * operator_id (a user id).
 */
const useAgendaOperators = () => {
    const {data, isLoading} = useSwr('access/current/team', () => teamApi().index());

    const operators = computed(() => operatorsFromAccesses(data.value?.team ?? []));

    /** Members an appointment can actually be assigned to. */
    const assignableOperators = computed(() => operators.value.filter((operator) => operator.assignable));

    return {
        operators,
        assignableOperators,
        isLoading
    };
};

export default useAgendaOperators;
